<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>
        New draws
      </mat-card-title>
      <mat-select class="month-select"
                  [(ngModel)]="currentMonth"
                  placeholder="Month"
                  (selectionChange)="filterByMonth($event.value)">
        <mat-option *ngFor="let i of months"
                    [value]="i">{{i}}</mat-option>
      </mat-select>
    </mat-card-header>
    <mat-card-content>
      <ifb-vertical-bar-chart [options]="chartData.options"
                              [view]="chartData.view"
                              [data]="chartData.data">
      </ifb-vertical-bar-chart>
    </mat-card-content>
  </mat-card>
</ifb-card>
